<template>
  <el-dialog
    top="300px"
    width="520px"
    height="193px"
    :visible="renameDialog"
    @close="close"
    :title="dialogParams.title"
  >
    <div v-if="dialogParams.isNew" class="h-8 leading-8 new-tip-word -mx-4">
      <p class="ml-4">请先新建一个指标统计表，完成后进行统计维度配置</p>
    </div>
    <el-form ref="crossRef" :model="form" size="small" class="mt-6">
      <el-form-item label="" prop="name">
        <el-input v-model="form.name" size="medium" placeholder="请输入统计表名称" clearable :style="{ width: '100%' }">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <!-- <el-button @click="close" class="cancel">取 消</el-button> -->
      <el-button type="primary" @click="handelConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import GlobalConfig from '@/global/config'
import { indicatorStatisticsCreate, indicatorStatisticsUpdate,indicatorDimensionUpdate } from '@/api/index-statistics'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    renameDialog: {
      type: Boolean,
      require: true
    },
    dialogParams: {
      type: Object,
      default() {
        return {
          title: '新建指标统计表',
          id: '',
          name: ''
        }
      }
    }
  },
  data() {
    return {
      form: {
        name: '',
        crossId: ''
      }
    }
  },
  computed: {
    ...mapGetters(['indexStatInfo']),
    getSurveyId() {
      return GlobalConfig.getSurveyId()
    }
  },
  watch: {
    dialogParams(v) {
      this.form.name = v.name
      this.form.crossId = v.id
    }
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.$emit('update:renameDialog', false)
    },
    // 创建指标统计表
    createStat(name) {
      indicatorStatisticsCreate({
        name: name
      }).then(res => {
        if(res.data.code == 0 && res.data.data){
          this.$message.success('新建成功！')
          this.$emit('update:addStatId', res.data.data)
          this.$parent.getStatList();
          this.$parent.tableType = 0
        }else{
          this.$message.error(res.data.msg || '新建失败！')
        }
      })
    },
    // 修改指标统计表
    updateStat(name) {
      indicatorStatisticsUpdate({
        id: this.dialogParams.id,
        name: name
      }).then(res => {
        if(res.data.code == 0 && res.data.data){
          this.$message.success('修改成功！')
          this.$emit('update:addStatId', res.data.data)
          this.$parent.getStatList();
        }else{
          this.$message.error(res.data.msg || '修改失败！')
        }
      })
    },
    // 修改指标维度名
    updateDimensionName(name){
      let obj = this.dialogParams.data
      obj.name = name
      indicatorDimensionUpdate(obj).then(res => {
        if(res.data.code == 0 && res.data.data){
          this.$message.success('修改成功！')
        }else{
          this.$message.error(res.data.msg || '修改失败！')
        }
        this.$parent.$parent.getIndexDimensionList();
        // 更新表格
        this.$parent.$parent.updataCellTable()
      })
    },
    handelConfirm() {
      let name = this.form.name.trim()
      if (!name) {
        this.$message.warning('请输入名称')
        return
      }
      this.$emit('update:renameDialog', false)
      if (this.dialogParams.title == '新建指标统计表') {
        this.createStat(name)
      } else if (this.dialogParams.title == '编辑指标统计表名称') {
        this.updateStat(name)
      } else if (this.dialogParams.title == '编辑指标名称') {
        if(this.dialogParams.treetype == 1) {
          this.updateDimensionName(name)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  background: #f5f7fa;
  padding: 12px 20px;
  border-radius: 2px;
  overflow: hidden;
}
::v-deep .el-dialog__headerbtn .el-dialog__close{
  font-size: 18px !important;
}
// 设置表单中间高度
::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 0;
}
::v-deep .el-dialog__body {
  padding: 0 16px 24px;
}
::v-deep .el-dialog__footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px;
  .el-button {
    width: 88px;
    height: 32px;
  }

  .cancel {
    border: 1px solid #ccc;
    color: rgba(0, 0, 0, 0.45);
  }
}
.new-tip-word{
  background: #FFFCEB;
  p{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #E8A31B;
  }
}
</style>
